import { CONTACT, OPERATOR, formatAddress } from "@/lib/legal";

export function OperatorContact() {
  return (
    <address className="not-italic">
      <strong>{OPERATOR.name}</strong> (operator, {OPERATOR.product})
      <br />
      {formatAddress()}
      <br />
      <a href={`mailto:${CONTACT.support}`} className="text-primary dark:text-primary-dark">
        {CONTACT.support}
      </a>
      {" · "}
      <a href={`mailto:${CONTACT.help}`} className="text-primary dark:text-primary-dark">
        {CONTACT.help}
      </a>
      <br />
      {CONTACT.phones.map((phone, i) => (
        <span key={phone}>
          {i > 0 ? " · " : null}
          <a href={`tel:${phone.replace(/\s/g, "")}`} className="text-primary dark:text-primary-dark">
            {phone}
          </a>
        </span>
      ))}
    </address>
  );
}
